export class AppSpinner {
  #appSpinnerElement: HTMLElement
  #showWithDelay = false
  #timeoutId: number | null = null

  constructor(inletElement: HTMLElement) {
    this.#appSpinnerElement = inletElement.getElementsByClassName('external-widget-loader-loading')[0] as HTMLElement
  }

  show(inMillis = 1000) {
    this.#showWithDelay = true
    if (this.#timeoutId) {
      clearTimeout(this.#timeoutId)
    }
    this.#timeoutId = window.setTimeout(() => {
      if (this.#appSpinnerElement && this.#showWithDelay) {
        this.#showWithDelay = false
        this.#appSpinnerElement.style.display = 'block'
      }
    }, inMillis)
  }

  showImmediate() {
    if (this.#appSpinnerElement) {
      this.#appSpinnerElement.style.display = 'block'
    }
  }

  hide() {
    if (this.#appSpinnerElement) {
      this.#showWithDelay = false
      if (this.#timeoutId) {
        clearTimeout(this.#timeoutId)
      }
      this.#appSpinnerElement.style.display = 'none'
    }
  }
}
